/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistRequest
 */
export interface CreateOrganizationIPWhitelistRequest {
    /**
     * The IP address or CIDR notation to whitelist (e.g., 192.168.1.1 or 192.168.1.0/24)
     */
    ip_address: string;
    /**
     * Optional description for the IP address
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistRequest interface.
 */
export function instanceOfCreateOrganizationIPWhitelistRequest(value: object): value is CreateOrganizationIPWhitelistRequest {
    if (!('ip_address' in value) || value['ip_address'] === undefined) return false;
    return true;
}

export function CreateOrganizationIPWhitelistRequestFromJSON(json: any): CreateOrganizationIPWhitelistRequest {
    return CreateOrganizationIPWhitelistRequestFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ip_address': json['ip_address'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateOrganizationIPWhitelistRequestToJSON(json: any): CreateOrganizationIPWhitelistRequest {
    return CreateOrganizationIPWhitelistRequestToJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistRequestToJSONTyped(value?: CreateOrganizationIPWhitelistRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ip_address': value['ip_address'],
        'description': value['description'],
    };
}

